import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Flex, Tooltip } from "antd"
import { Icon } from "ui/Icon"
import { numberToCurrency } from "helpers/string"
import { getBookableTicketTypes } from "../../helpers"
import styles from "./TicketedDetails.module.css"

// "Ticket Types & Prices": each enabled ticket type with its base price, before any day, season
// or discount change (those show in the booking panel). The info icon shows the type's description.
const TicketTypesSection = ({ ticketTypes }) => {
  const { t } = useTranslation()
  const visibleTypes = getBookableTicketTypes({ ticket_types: ticketTypes })
  if (visibleTypes.length === 0) return null

  return (
    <Flex vertical gap={16} className={styles.section}>
      <h2 className={styles.sectionTitle}>{t("booking_widget.experience.ticket_types.title")}</h2>
      <div className={styles.ticketGrid}>
        {visibleTypes.map((ticketType) => (
          <Flex key={ticketType.id} align="center" gap={12} className={styles.ticketCard}>
            <Flex align="center" gap={4} className={styles.ticketName}>
              <span>{ticketType.title}</span>
              {ticketType.description && (
                <Tooltip title={ticketType.description}>
                  <button
                    type="button"
                    className={styles.infoButton}
                    aria-label={t("booking_widget.experience.ticket_types.info", { title: ticketType.title })}
                  >
                    <Icon type="feather" name="Info" width={20} height={20} color="currentColor" />
                  </button>
                </Tooltip>
              )}
            </Flex>
            {ticketType.price != null && (
              <span className={styles.ticketPrice}>
                <span className={styles.ticketPriceFrom}>{t("booking_widget.experience.ticket_types.from")}</span>{" "}
                {numberToCurrency(ticketType.price)}
              </span>
            )}
          </Flex>
        ))}
      </div>
    </Flex>
  )
}

TicketTypesSection.propTypes = {
  ticketTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      title: PropTypes.string,
      description: PropTypes.string,
      enabled: PropTypes.bool,
      price: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  )
}

TicketTypesSection.defaultProps = {
  ticketTypes: []
}

export default TicketTypesSection
